export const USER_CURRENT = "user/current";
